import { Point2 } from '../../../../domain/geometry/geometric-types';
import { SheetPolygon } from '../SheetPolygon';
import { Diamond } from './wedge-types';

type ProtanDiamondProps = {
  trianglePoints: Point2[][];
  getPointInDomCoordinateSystem: (pointInPdf: Point2) => Point2;
  diamond: Diamond;
  isSelectable?: boolean;
  isSelected?: boolean;
  onClick?: React.MouseEventHandler;
};

export default function ProtanDiamond({
  trianglePoints,
  getPointInDomCoordinateSystem,
  diamond,
  isSelected = false,
  isSelectable = false,
  onClick,
}: ProtanDiamondProps) {
  const wedgeColor = isSelectable
    ? isSelected
      ? 'blue.300'
      : 'green.300'
    : 'orange.200';
  const strokeWidth = 2;

  // Handle click while preventing text selection
  const handleClick: React.MouseEventHandler = (e) => {
    // Prevent default browser behavior to avoid text selection
    e.preventDefault();

    if (onClick) {
      onClick(e);
    }
  };

  const diamondTriangles = [
    { key: 'triangle1', points: trianglePoints[0] },
    { key: 'triangle2', points: trianglePoints[1] },
    { key: 'triangle3', points: trianglePoints[2] },
    { key: 'triangle4', points: trianglePoints[3] },
  ];

  return (
    <>
      {diamondTriangles.map(({ key, points }) => (
        <SheetPolygon
          key={key}
          fillOpacity={diamond[key as keyof Diamond] ? 0.1 : 0}
          fill={diamond[key as keyof Diamond] ? wedgeColor : undefined}
          strokeWidth={strokeWidth}
          stroke={diamond[key as keyof Diamond] ? wedgeColor : undefined}
          multipolygon={{
            polygons: [
              {
                exterior: points,
                interiors: [],
              },
            ],
          }}
          getPointInDomCoordinateSystem={getPointInDomCoordinateSystem}
          onClick={handleClick}
          selectable={isSelectable}
          // Disable text selection via CSS
          sx={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }}
        />
      ))}
    </>
  );
}
